<template>
  <v-dialog v-if="dialog" v-model="dialog" max-width="500px" persistent>
    <v-card class="pa-3">
      <v-card-title>
          <h2 class="title">Add Credit Card</h2>
      </v-card-title>
      <div class="pa-3">
        <div class="dialog-heading mb-3 mt-3 px-3">
          Credit Card Info
        </div>
        <v-flex class="xs12 px-4">
            <card-form @focus="resetServerValidation" @resetServer="resetServerValidation" @token="submitAddCardData($event)" @state="stripe_state = $event" :formBus="formBus"></card-form>
        </v-flex>
        <v-alert class="pa-2 mt-3" :value="stripe_state.cardErrorMessage.length > 0 || stripe_state.nameErrorMessage.length > 0" outlined color="error" icon="mdi-alert" transition="scale-transition">
            <span class="caption">Please fill out all fields correctly</span>
        </v-alert>
        <v-alert class="pa-2 mt-3" :value="!serverValidation" outlined color="error" icon="mdi-alert" transition="scale-transition">
            <span class="caption">{{ serverValidationMessage }}</span>
        </v-alert>
      </div>
      <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="closeModal">Cancel</v-btn>
          <v-btn color="primary" :loading="loadingSave" :disabled="loadingSave" @click="addCard">Add Credit Card</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import ApiService from "@/common/api.service"
  import Vue from "vue";
  import CardForm from '@/components/CardForm.vue'

    export default {
        name: 'AdminAddCreditCard',
        components: {
          CardForm
        },
        data: () => ({
          formBus: new Vue(),
          no_data: [null, "", undefined, "null"],
          item: null,
          preparedData: {},
          bannerTypes: [],
          loading: false,

          stripe_state: {
            cardErrorMessage: '',
            nameErrorMessage: '',
            complete: false
          },
          dialog: false,
          loadingSave: false,
          addCardData: {},

          serverValidation: true,
          serverValidationMessage: "Oops something went wrong...",
          server_errors: {}
        }),
        mounted() {
            this.$root.$on('AddCreditCard', this.openModal)
        },
        beforeDestroy() {
            this.$root.$off('AddCreditCard', this.openModal)
        },
        methods: {
          askForStripeToken() {
              this.formBus.$emit('gaveMeToken')
          },
          openModal() {
            this.addCardData = {}
            this.resetServerValidation()
            this.stripe_state = {
              cardErrorMessage: '',
              nameErrorMessage: '',
              complete: false
            },
            this.dialog = true;
          },
          addCard() {
              this.resetServerValidation()
              this.askForStripeToken()
              if(this.stripe_state.complete) {
                this.loadingSave = true
              }
          },
          submitAddCardData(token) {
              let data = {};
              if(token.error === undefined) {
                  data.stripeToken = token.token.id
                  data.organization_id = this.$route.params.organization_id
              } else {
                  this.loadingSave = false
                  return
              }
              ApiService.put('/admin/credit_card', data)
                  .then(res => {
                    this.closeModal();
                    this.$root.$emit('notification', {status: 'success', 'text': 'New Card has been successfully added.'});
                    this.$emit('done')
                    this.loadingSave = false
                  })
                  .catch(({ response }) => {
                      this.loadingSave = false
                      this.serverValidation = false
                      if(response.data.error){
                          this.serverValidationMessage = _.upperFirst(res.data.error.replace(/_/g, ' '))
                      }
                  })
                  .catch(err => {
                    console.log(err)
                  })
          },
          closeModal() {
              this.dialog = false;
          },
          titleCase(str) {
              return _.startCase(str.replace(/_/g, " "));
          },
          resetServerValidation() {
              this.serverValidation = true;
              this.serverValidationMessage = "Oops something went wrong...";
              this.server_errors = {};
          },
        }
    }
</script>
